import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { PreviousQuestionId } from '../previous-question-id';
import { QuestionType } from '../question-type';
export var Questions = /*#__PURE__*/function () {
  function Questions() {
    _classCallCheck(this, Questions);
  }

  _createClass(Questions, null, [{
    key: "getQuestionIndex",
    value: function getQuestionIndex(previousQuestion) {
      var index;

      if (previousQuestion) {
        index = previousQuestion.type === QuestionType.FillInBlank || previousQuestion.type === QuestionType.Matching ? previousQuestion.nextIndex : previousQuestion.index + 1;
      } else {
        index = 1;
      }

      return index;
    }
  }, {
    key: "addIndex",
    value: function addIndex(questions) {
      var _this = this;

      return questions.map(function (q) {
        var previousQuestion = questions.find(function (question) {
          return question.id.toString() === q.previousQuestionId;
        });

        var index = _this.getQuestionIndex(previousQuestion);

        if (q.type === QuestionType.FillInBlank) {
          q.addIndex(index);
          q.addNextIndex(index + q.answers.length);
          return q;
        }

        if (q.type === QuestionType.Matching) {
          q.addIndex(index);
          q.addNextIndex(index + q.subQuestions.length);
          return q;
        } else {
          q.addIndex(index);
          return q;
        }
      });
    }
  }, {
    key: "sortQuestions",
    value: function sortQuestions(questions) {
      if (questions.length === 0) {
        return [];
      }

      if (questions.length === 1) {
        return this.addIndex(questions);
      }

      var sortedQuestions = [];
      var headQuestion = questions.find(function (question) {
        return question.previousQuestionId === PreviousQuestionId.none.id.toString();
      });
      if (headQuestion) sortedQuestions.push(headQuestion);
      var currentQuestionId = headQuestion === null || headQuestion === void 0 ? void 0 : headQuestion.id.toString();
      questions.forEach(function () {
        var nextQuestion = questions.find(function (question) {
          var _question$previousQue;

          return ((_question$previousQue = question.previousQuestionId) === null || _question$previousQue === void 0 ? void 0 : _question$previousQue.toString()) === currentQuestionId;
        });

        if (!nextQuestion) {
          return;
        }

        sortedQuestions.push(nextQuestion);
        currentQuestionId = nextQuestion.id.toString();
      });
      return this.addIndex(sortedQuestions);
    }
  }, {
    key: "sortQuestionsWithIndexAndSection",
    value: function sortQuestionsWithIndexAndSection(questions) {
      var _this2 = this;

      if (questions.length === 0) {
        return [];
      }

      var mapSections = new Map(); // eslint-disable-next-line no-loops/no-loops

      var _iterator = _createForOfIteratorHelper(questions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _question = _step.value;

          var sectionId = _question.sectionId.toString();

          if (mapSections.has(sectionId)) {
            var questionsOfSection = mapSections.get(sectionId);
            questionsOfSection.push(_question);
            mapSections.set(sectionId, questionsOfSection);
          } else {
            var _questionsOfSection = [_question];
            mapSections.set(sectionId, _questionsOfSection);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var sortedQuestions = [];
      mapSections.forEach(function (value) {
        sortedQuestions.push.apply(sortedQuestions, _toConsumableArray(_this2.sortQuestions(value)));
      });
      var weightOfIndex = 1;
      var newSortedQuestions = [];

      for (var index = 0; index < sortedQuestions.length; index++) {
        var question = sortedQuestions[index];

        if (question.type === QuestionType.Matching || question.type === QuestionType.FillInBlank) {
          var weight = question.nextIndex - question.index;
          question.addIndex(weightOfIndex);
          question.addNextIndex(question.index + weight);
          weightOfIndex = question.index + weight;
        } else {
          question.addIndex(weightOfIndex);
          weightOfIndex++;
        }

        newSortedQuestions.push(question.clone());
      }

      return newSortedQuestions;
    }
  }, {
    key: "hasEssayOrFillInBlankQuestion",
    value: function hasEssayOrFillInBlankQuestion(questions) {
      return questions.some(function (q) {
        return q.type === QuestionType.Essay || q.type === QuestionType.FillInBlank;
      });
    }
  }, {
    key: "getQuestionCount",
    value: function getQuestionCount(question) {
      var _answers$length, _answers, _subQuestions$length, _subQuestions;

      switch (question.type) {
        case QuestionType.FillInBlank:
          return (_answers$length = (_answers = question.answers) === null || _answers === void 0 ? void 0 : _answers.length) !== null && _answers$length !== void 0 ? _answers$length : 0;

        case QuestionType.Matching:
          return (_subQuestions$length = (_subQuestions = question.subQuestions) === null || _subQuestions === void 0 ? void 0 : _subQuestions.length) !== null && _subQuestions$length !== void 0 ? _subQuestions$length : 0;

        default:
          return 1;
      }
    }
  }, {
    key: "getTotalQuestions",
    value: function getTotalQuestions() {
      var _this3 = this;

      var questions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return questions.reduce(function (sum, question) {
        return sum + _this3.getQuestionCount(question);
      }, 0);
    }
  }, {
    key: "getTotalScore",
    value: function getTotalScore() {
      var questions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return questions.reduce(function (sum, question) {
        return sum + (Number(question.score) || 0);
      }, 0);
    }
  }]);

  return Questions;
}();